import {
	Column
} from 'devextreme-react/data-grid';

import { SyncDataGrid } from '../../../../components';
import { Link } from 'react-router-dom';
import { formatDate } from 'devextreme/localization';

export default function PaymentScheduleGrid(props: { records: any[], date: Date, showClickSearch?: boolean }) {

	return (
		<>
			<SyncDataGrid
				stateStorageKey='payment-schedule-grid'
				className="dx-card wide-card"
				dataSource={props.records}
				height="62vh"
				noDataText={props.showClickSearch? 'Click Search to retrieve data': 'No Data'}
			>
				<Column
					dataField={'isPromo'}
					caption={'Type'}
					dataType="string"
					alignment="center"
					calculateDisplayValue={(rowData) => { return rowData.isPromo ? "PROMO" : "STANDARD" }}
				/>

				<Column
					dataField={'adPatchCode'}
					caption={'Patch'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'storeNumber'}
					caption={'Store Number'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'storeCity'}
					caption={'Store City'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'storeState'}
					caption={'Store State'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'priceBucketCode'}
					caption={'Schedule'}
					dataType="string"
					alignment="center"
					cellRender={(row) => {
						return <Link to={`/cfi/payment-schedule/details?priceBucketID=${row.data.priceBucketID}&priceBucketVersioningID=${row.data.priceBucketVersioningID}&date=${formatDate(props.date, 'yyyy-MM-dd')}`}
							target="_blank">
							{row.data.priceBucketCode}
						</Link>;
					}}
				/>
				<Column
					dataField={'startDate'}
					caption={'Start Date'}
					dataType="date"
					alignment="center"
				/>
				<Column
					dataField={'endDate'}
					caption={'End Date'}
					dataType="date"
					alignment="center"
				/>
			</SyncDataGrid>
		</>
	)
} 
